import { Box, Text, useBreakpointValue } from '@chakra-ui/react';
import { AssistantQuery } from '@/components/dashbaord/assistant/types.ts';
import React, { useEffect, useRef, useState } from 'react';

interface ChatQueryProps {
	query: AssistantQuery;
}

const ChatQuery: React.FC<ChatQueryProps> = (props: ChatQueryProps) => {
	const { query } = props;
	const queryRef = useRef<HTMLParagraphElement>(null);
	const [isMultiLine, setIsMultiLine] = useState(false);
	const isMobile = useBreakpointValue({ base: true, md: false });

	useEffect(() => {
		if (queryRef.current) {
			const lineHeight = parseInt(getComputedStyle(queryRef.current).lineHeight, 10) || 16;
			const lines = Math.ceil(queryRef.current.offsetHeight / lineHeight);
			setIsMultiLine(lines > 2); // Check if text spans more than 2 lines
		}
	}, [query.text]); // Recalculate when the query changes

	return (
		<Box
			alignSelf="end"
			bg="primary/06"
			p={4}
			py={3}
			position="sticky"
			zIndex={9}
			borderRadius={isMultiLine ? '2xl' : 'full'}
			borderBottomRightRadius={0}
			w={isMobile ? '100%' : 'min-width'}
		>
			<Text textAlign="left" fontSize={{ base: 'sm', md: '1rem' }} lineHeight={1.5}>
				{query.text}
			</Text>
		</Box>
	);
};

export default ChatQuery;
